<template>
  <div class="grid_main mb-5">
    <div class="d-flex flex-column mr-md-2">
      <v-sheet width="100%" min-height="30" class="main_info">
        <div>{{ main_header.project }}</div>
        <div>{{ left[0] || '-' }}</div>
      </v-sheet>
      <v-sheet width="100%" min-height="30" class="main_info">
        <div>{{ main_header.address }}</div>
        <div>{{ left[1] || '-' }}</div>
      </v-sheet>
      <v-sheet width="100%" min-height="30" class="main_info">
        <div>{{ main_header.dates }}</div>
        <div>{{ left[2] || '-' }}</div>
      </v-sheet>
      <v-sheet v-if="left[3]" width="100%" min-height="30" class="main_info">
        <div>{{ main_header.employee }}</div>
        <div>{{ left[3] || '-' }}</div>
      </v-sheet>
    </div>
    <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp" />
    <div class="ml-md-2">
      <v-sheet width="100%" min-height="30" class="main_info">
        <div>{{ main_header.name }}</div>
        <div>{{ right[0] || '-' }}</div>
      </v-sheet>
      <v-sheet width="100%" min-height="30" class="main_info">
        <div>{{ main_header.operator }}</div>
        <div>{{ right[1] || '-' }}</div>
      </v-sheet>
      <v-sheet width="100%" min-height="30" class="main_info">
        <div>{{ main_header.phone }}</div>
        <div>{{ right[2] || '-' }}</div>
      </v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatisticProjectReportsBlankMainTable',
  props: {
    left: {
      type: Array,
      default: () => {
        return []
      },
    },
    right: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    main_header() {
      return {
        project: this.localStorage.translations.pages.finance['period-table']['project'],
        address: this.localStorage.translations.pages.finance['period-table']['address'],
        dates: this.localStorage.translations.pages.finance['period-table']['term'],
        employee: this.localStorage.translations.pages.finance['period-table']['employee'],
        name: this.localStorage.translations.pages.finance['period-table']['client'],
        operator: this.localStorage.translations.pages.finance['period-table']['subscriber'],
        phone: this.localStorage.translations.pages.finance['period-table']['tel'],
      }
    }
  }
}
</script>

<style scoped lang="scss">
.grid_main {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr auto 1fr;

    @media #{map-get($display-breakpoints, 'sm-and-down')} {
        grid-template-columns: 1fr;
    }

    & div {
        min-height: 30px;
        min-width: 32px;
        //padding: 4px 6px;
    }
}

.main_info {
    display: grid;
    grid-template-columns: 100px 1fr;
    grid-template-rows: auto;
    border-bottom: 1px solid #ebebeb !important;
    padding: 0 !important;

    & div {
        padding: 0 !important;
        display: flex;
        align-items: center;
        line-height: 1.4em;
    }
}
</style>
